import { type SvgProps, SvgWrapper } from '../utils';

export function ArrowUpIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11.25 19V6.81054L5.53028 12.5303C5.23738 12.8232 4.76262 12.8232 4.46973 12.5303C4.17684 12.2374 4.17684 11.7626 4.46973 11.4697L11.4697 4.46972L11.5264 4.41796C11.821 4.17765 12.2557 4.19512 12.5303 4.46972L19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303C19.2374 12.8232 18.7626 12.8232 18.4697 12.5303L12.75 6.81054V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19Z" />
    </SvgWrapper>
  );
}
